<template>
  <div class="collage">
    <img src="/figures/collage/media-collage.png" />

    <!-- Test of filling in content w/ UI background – went unused -->
    <!-- <div class="collage-frame">
      <div class="collage-frame__background">
        <img src="/figures/collage/bitrot-frame.png">
      </div>
      <div class="collage-frame__media media--bitrot">
        <video controls autoplay loop muted>
          <source src="/figures/collage/BITROT[V10101A EDIT]_STRUDEL_DEMO-@v10101a.mp4" type="video/mp4" />
        </video>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "MediaCollage",
  props: {
  },
  data() {
    return {
    };
  },
  computed: {},
  mounted() {
    
  },
  methods: {
    
  },
};
</script>

<style>

.collage {
  display: flex;
  padding-left: 5rem;
  padding-right: 5rem;
}

@media screen and (max-width: 775px){
  .collage {
    padding: 0;
  }
}






/* Test w/ UI Background – Went unused  */
.collage-frame {
  max-width: 300px;
  position: relative;
  display: flex;
}

.collage-frame__background {
  position: relative;
}

.collage-frame__media {
  position: absolute;
  z-index: 10;
  display: flex;
  margin-left: 11%;
  width: calc(100% - 22%);
  bottom: 9%;
  height: auto;
}

.collage-frame__media img, 
.collage-frame__media video {
  width: 100%;
  height: 100%;
  border: 1px solid #252527;
  border-radius: 4px;
  overflow: hidden;
}

</style>
